import { requestGet, requestPost } from '@/utils/request';

const api = {
    TREE: '/system/func_tree',
    ITEM: '/system/func_item',
    ADD: '/system/func_add',
    UPDATE: '/system/func_update',
    DELETE: '/system/func_del',
    NAME_IS_EXIST: '/system/func_name_is_exist',
    ROUTER_IS_EXIST: '/system/func_router_is_exist'
}

export async function funcTree() {
    return requestGet(api.TREE);
}

export async function funcItem(id) {
    let params = {id: id};
    return requestGet(api.ITEM, params);
}

export async function funcAdd(params) {
    return requestPost(api.ADD, params);
}

export async function funcUpdate(params) {
    return requestPost(api.UPDATE, params);
}

export async function funcDelete(id) {
    let params = {id: id};
    return requestPost(api.DELETE, params);
}

export async function funcNameIsExist(name) {
    let params = {val: name};
    return requestGet(api.NAME_IS_EXIST, params);
}

export async function funcRouterIsExist(router) {
    let params = {val: router}
    return requestGet(api.ROUTER_IS_EXIST, params);
}